import React from 'react'
import './youtube.css'
function Youtube() {
    return (
        <div className='youtube' >
            <h1>Youtube</h1>
            <br></br>
            <div className='videoContent'>
                <h3>How to install python in visual studio code in windows 10 2021</h3>
            <iframe src="https://www.youtube.com/embed/NHOMbaSP4Z0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
            <br></br>
            <div className='videoContent'>
                <h3>How to convert hour to seconds using python</h3>
                <iframe src="https://www.youtube.com/embed/gkrThK3lT_8" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
            <br></br>
            <div className='videoContent'>
                <h3>How to calculate area with Python</h3>
                <iframe src="https://www.youtube.com/embed/mUBfUaVel5M" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
            <br></br>
            <div className='videoContent'>
                <h3>How old will you be in 100 years Python</h3>
                <iframe src="https://www.youtube.com/embed/q1TZmJPVgNo" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
            <br></br>
            <div className='videoContent'>
                <h3>Which year will you be turning 100 years old with python</h3>
                <iframe src="https://www.youtube.com/embed/BuILfcjtrwI" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
            <br></br>
            <div className='videoContent'>
                <h3>How to calculate area with Python</h3>
                <iframe src="https://www.youtube.com/embed/2kl9Kjbycew" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
            <br></br>
            <div className='videoContent'>
                <h3>How to calculate average with python</h3>
                <iframe src="https://www.youtube.com/embed/2kl9Kjbycew" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
            <br></br>
            <div className='videoContent'>
                <h3>How to create a guess number game with python part 1</h3>
                <iframe src="https://www.youtube.com/embed/xZafYO8E_uY" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
            <br></br>
            <div className='videoContent'>
                <h3>How to create a guess number game with python part 2</h3>
                <iframe  src="https://www.youtube.com/embed/Yb-PDRQKz0Q" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
            <div className='videoContent'>
                <h3>How to calculate Range with python</h3>
                <iframe src="https://www.youtube.com/embed/di3dKonYu74" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
            <div className='videoContent'>
                <h3>How to create Python Rock Paper Scissors (Beginner tutorial)</h3>
                <iframe src="https://www.youtube.com/embed/ry0ZJFqdDFU" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
           
          
        </div>

    )
}

export default Youtube
